module.exports = __webpack_public_path__ + "static/media/amex.fb803771.svg";


//////////////////
// WEBPACK FOOTER
// ./~/payment-icons/min/single/amex.svg
// module id = 490
// module chunks = 0